var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6429 0H1.3529C0.606473 0 0 0.614956 0 1.36987V17.6301C0 18.385 0.606473 19 1.3529 19H17.6429C18.3893 19 19 18.385 19 17.6301V1.36987C19 0.614956 18.3893 0 17.6429 0ZM5.74241 16.2857H2.92634V7.2183H5.74665V16.2857H5.74241ZM4.33437 5.97991C3.43103 5.97991 2.70156 5.24621 2.70156 4.3471C2.70156 3.44799 3.43103 2.71429 4.33437 2.71429C5.23348 2.71429 5.96719 3.44799 5.96719 4.3471C5.96719 5.25045 5.23772 5.97991 4.33437 5.97991ZM16.2984 16.2857H13.4824V11.875C13.4824 10.8232 13.4612 9.47031 12.0192 9.47031C10.5518 9.47031 10.327 10.6154 10.327 11.7987V16.2857H7.51094V7.2183H10.2125V8.4567H10.2507C10.6281 7.7442 11.5484 6.99353 12.9183 6.99353C15.7683 6.99353 16.2984 8.87232 16.2984 11.3152V16.2857Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBw);
export default __webpack_public_path__ + "static/media/linkedin-bw.1c4a2e294ad14170b52755962139a2ed.svg";
export { ForwardRef as ReactComponent };